// Mega Menu Animation Script with ScrollSmoother Integration and Scroll Position Fix
document.addEventListener("DOMContentLoaded", function () {
  // Get ScrollSmoother instance (assumes it's already initialized)
  let smoother = ScrollSmoother.get();
  
  // If ScrollSmoother isn't ready yet, wait for it
  if (!smoother) {
    // Try to get it after a short delay
    setTimeout(() => {
      smoother = ScrollSmoother.get();
    }, 100);
  }

  // Scroll position preservation variables
  let scrollY = 0;

  // Get elements
  const menuButton = document.querySelector(".mega-menu__button");
  const megaMenu = document.querySelector(".mega-menu");
  const closeButton = document.querySelector(".mega-menu__button--close");
  const backButton = document.querySelector(".mega-menu__button--back");
  const searchButton = document.querySelector(".mega-menu__button--search");
  const closeText = document.querySelector(".mega-menu__close-text");
  const megaMenuLogo = document.querySelector(".mega-menu__logo");
  const navigationGrid = document.querySelector(".mega-menu__navigation-grid");
  const parentColumn = document.querySelector(".mega-menu__column--parents");
  const childrenColumn = document.querySelector(".mega-menu__column--children");
  const grandchildrenColumn = document.querySelector(
    ".mega-menu__column--grandchildren"
  );
  const childrenInner = childrenColumn?.querySelector(
    ".mega-menu__column-inner"
  );
  const grandchildrenInner = grandchildrenColumn?.querySelector(
    ".mega-menu__column-inner"
  );
  const childrenContent = childrenColumn?.querySelector(
    ".mega-menu__column-content"
  );
  const grandchildrenContent = grandchildrenColumn?.querySelector(
    ".mega-menu__column-content"
  );
  const childrenTitle = childrenColumn?.querySelector(
    ".mega-menu__parent-title"
  );
  const grandchildrenTitle = grandchildrenColumn?.querySelector(
    ".mega-menu__parent-title"
  );
  const socialItems = document.querySelectorAll(".mega-menu__socials-item");
  const contactItems = document.querySelectorAll(".mega-menu__footer-contact");
  const searchWrapper = document.querySelector(".mega-menu__search-wrapper");

  // Check if elements exist
  if (!menuButton || !megaMenu) {
    console.warn("Mega menu elements not found");
    return;
  }

  // Check if mobile
  const isMobile = () => window.innerWidth <= 1024;

  // Animation settings
  const SLIDE_DURATION = 0.4;
  const SLIDE_EASE = "power2.out";

  let isMenuOpen = false;
  let currentParentId = null;
  let currentChildId = null;
  let menuData = {};
  let isAnimating = false;
  let navigationStack = [];
  let isChildrenColumnVisible = false;
  let isGrandchildrenColumnVisible = false;

  // Animation state tracking
  let isChildrenAnimating = false;
  let isGrandchildrenAnimating = false;
  let isContentAnimating = false;

  // ScrollSmoother control functions
  function pauseScrollSmoother() {
    if (smoother) {
      smoother.paused(true);
      ////console.log("ScrollSmoother paused");
    }
  }

  function resumeScrollSmoother() {
    if (smoother) {
      smoother.paused(false);
      //console.log("ScrollSmoother resumed");
    }
  }

  // Scroll position preservation functions
  function preserveScrollPosition() {
    // Store current scroll position
    scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    
    // Apply the fixed position with preserved scroll position
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.classList.add('mega-menu-open');
    
    //console.log(`Preserved scroll position: ${scrollY}px`);
  }

  function restoreScrollPosition() {
    // Remove the fixed positioning
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.classList.remove('mega-menu-open');
    
    // Restore the scroll position
    window.scrollTo(0, scrollY);
    
    //console.log(`Restored scroll position: ${scrollY}px`);
  }

  // Kill all column animations
  function killAllColumnAnimations() {
    gsap.killTweensOf([childrenColumn, childrenContent, grandchildrenColumn, grandchildrenContent]);
    isChildrenAnimating = false;
    isGrandchildrenAnimating = false;
    isContentAnimating = false;
  }

  // Reset animation states
  function resetAnimationStates() {
    isChildrenAnimating = false;
    isGrandchildrenAnimating = false;
    isContentAnimating = false;
  }

  // Set initial states
  gsap.set(megaMenu, {
    top: "-100dvh",
  });

  gsap.set(megaMenuLogo, {
    x: -100,
    opacity: 0,
  });

  gsap.set(closeButton, {
    x: 100,
    opacity: 0,
  });

  gsap.set(searchButton, {
    x: 100,
    opacity: 0,
  });

  gsap.set(closeText, {
    x: 20,
    opacity: 0,
  });

  gsap.set(parentColumn, {
    x: "-100%",
    opacity: 0,
  });

  // Fix: Set initial opacity to 1 for children and grandchildren columns
  gsap.set(childrenColumn, {
    x: isMobile() ? "100%" : "-100%",  // Start from right on mobile
    opacity: 1,
    visibility: "visible",
  });

  gsap.set(grandchildrenColumn, {
    x: isMobile() ? "100%" : "-100%",  // Start from right on mobile
    opacity: 1,
    visibility: "visible",
  });

  gsap.set(socialItems, {
    opacity: 0,
    y: 20,
  });

  gsap.set(contactItems, {
    opacity: 0,
    y: 20,
  });

  gsap.set(".mega-menu__list--parents > li", {
    opacity: 0,
    x: -50,
  });

  // Mobile specific initial states
  if (isMobile()) {
    gsap.set(backButton, {
      x: 20,
      opacity: 0,
      visibility: "hidden",
    });
  }

  // Set initial state for search wrapper
  if (searchWrapper && isMobile()) {
    gsap.set(searchWrapper, {
      opacity: 0,
      x: -50,
    });
  }

  // Create main menu timeline
  const menuTimeline = gsap.timeline({
    paused: true,
    onComplete: function () {
      showParentColumn();
    },
    onReverseComplete: function () {
      // Resume ScrollSmoother when menu is fully closed
      resumeScrollSmoother();
      
      // Reset all elements to initial state
      gsap.set(
        [
          megaMenu,
          megaMenuLogo,
          closeButton,
          searchButton,
          closeText,
          parentColumn,
          childrenColumn,
          grandchildrenColumn,
        ],
        {
          clearProps: "all",
        }
      );

      // Re-apply initial hidden states
      gsap.set(megaMenu, { 
        top: "-100dvh",
        visibility: "hidden",
        opacity: 0
      });
      gsap.set(megaMenuLogo, { x: -100, opacity: 0 });
      gsap.set(closeButton, { x: 100, opacity: 0 });
      gsap.set(searchButton, { x: 100, opacity: 0 });
      gsap.set(closeText, { x: 20, opacity: 0 });
      gsap.set(parentColumn, { x: "-100%", opacity: 0 });

      // Fix: Set opacity to 1 for children and grandchildren columns
      gsap.set(childrenColumn, {
        x: "-100%",
        opacity: 1,
        visibility: "visible",
      });
      gsap.set(grandchildrenColumn, {
        x: "-100%",
        opacity: 1,
        visibility: "visible",
      });

      gsap.set(socialItems, { opacity: 0, y: 20 });
      gsap.set(contactItems, { opacity: 0, y: 20 });
      gsap.set(".mega-menu__list--parents > li", { opacity: 0, x: -50 });

      // Mobile specific resets
      if (isMobile()) {
        gsap.set(backButton, { x: 20, opacity: 0, visibility: "hidden" });
        navigationStack = [];
      }

      if (searchWrapper && isMobile()) {
        gsap.set(searchWrapper, {
          opacity: 0,
          x: -50,
        });
      }

      // Clear active states
      document
        .querySelectorAll(".mega-menu__list a.active")
        .forEach((a) => a.classList.remove("active"));

      // Clear any content in dynamic columns
      if (childrenContent) childrenContent.innerHTML = "";
      if (grandchildrenContent) grandchildrenContent.innerHTML = "";

      // Reset tracking variables
      currentParentId = null;
      currentChildId = null;
      isAnimating = false;
      isChildrenColumnVisible = false;
      isGrandchildrenColumnVisible = false;
    },
  });

  // Build animation sequence
  menuTimeline.to(megaMenu, {
    top: 0,
    visibility: "visible",
    opacity: 1,
    duration: 0.6,
    ease: "power2.inOut",
  });

  // Show parent column
  function showParentColumn() {
    // Animate parent column
    gsap.to(parentColumn, {
      x: "0%",
      opacity: 1,
      duration: SLIDE_DURATION,
      ease: SLIDE_EASE,
    });

    // Create a timeline for staggered animations
    const staggerTimeline = gsap.timeline({ delay: 0.4 });

    // If mobile and search wrapper exists, include it in the stagger
    if (isMobile() && searchWrapper) {
      // Get all menu items
      const menuItems = document.querySelectorAll(".mega-menu__list--parents > li");
      
      // Create an array with search wrapper first, then menu items
      const elementsToAnimate = [searchWrapper, ...menuItems];
      
      // Animate all elements together with stagger
      staggerTimeline.to(elementsToAnimate, {
        opacity: 1,
        x: 0,
        y: 0, // Reset y for search wrapper
        duration: 0.6,
        stagger: 0.08,
        ease: "power3.out",
      });
    } else {
      // Desktop - just animate menu items
      staggerTimeline.to(".mega-menu__list--parents > li", {
        opacity: 1,
        x: 0,
        duration: 0.6,
        stagger: 0.08,
        ease: "power3.out",
      });
    }

    // Animate logo
    gsap.to(megaMenuLogo, {
      x: 0,
      opacity: 1,
      duration: 0.4,
      ease: "power2.out",
    });

    // Animate close button
    gsap.to(closeButton, {
      x: 0,
      opacity: 1,
      duration: 0.4,
      ease: "power2.out",
      delay: 0.8,
    });

    // Animate search button
    gsap.to(searchButton, {
      x: 0,
      opacity: 1,
      visibility: "visible",
      duration: 0.4,
      ease: "power2.out",
      delay: 0.8,
    });

    if (!isMobile()) {
      // Animate close text (desktop only)
      gsap.to(closeText, {
        x: 0,
        opacity: 1,
        duration: 0.6,
        ease: "power3.out",
        delay: 1.2,
      });

      // Animate social items (desktop only)
      gsap.to(socialItems, {
        opacity: 1,
        y: 0,
        duration: 0.4,
        stagger: 0.05,
        ease: "power2.out",
        delay: 0.8,
      });
    }

    if (isMobile()) {
      gsap.to(contactItems, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: "power1.out",
        delay: 1.5,
      });
    }
  }

  // Show back button (mobile)
  function showBackButton() {
    if (!isMobile()) return;

    // Hide search button first - slide left and fade out
    gsap.to(searchButton, {
      x: -30,
      opacity: 0,
      duration: SLIDE_DURATION,
      ease: "power2.in",
      onComplete: () => {
        gsap.set(searchButton, { visibility: "hidden" });
        
        // After search button is hidden, show back button - slide in from right
        gsap.to(backButton, {
          x: 0,
          opacity: 1,
          visibility: "visible",
          duration: SLIDE_DURATION,
          ease: SLIDE_EASE,
        });
      }
    });
  }

  // Hide back button (mobile)
  function hideBackButton() {
    if (!isMobile()) return;

    // Hide back button first - slide right and fade out
    gsap.to(backButton, {
      x: 20,
      opacity: 0,
      duration: 0.4,
      ease: "power2.in",
      onComplete: () => {
        gsap.set(backButton, { visibility: "hidden" });
        
        // After back button is hidden, show search button - slide in from left
        gsap.to(searchButton, {
          x: 0,
          opacity: 1,
          visibility: "visible",
          duration: SLIDE_DURATION,
          ease: SLIDE_EASE,
        });
      },
    });
  }

  // Show children column
  function showChildrenColumn(parentId, parentTitle) {
    if (isMobile()) {
      // Mobile behavior - slide in from right with sequential animation
      currentParentId = parentId;
      currentChildId = null;
      navigationStack.push({
        type: "parent",
        id: parentId,
        title: parentTitle,
      });
      updateChildrenContent(parentId, parentTitle);
      showBackButton();

      // Slide parent column to the left
      gsap.to(parentColumn, {
        x: "-100%",
        duration: SLIDE_DURATION,
        ease: "power2.in",
        onComplete: () => {
          // Slide children column in from right AFTER parent slides out
          gsap.to(childrenColumn, {
            x: "0%",
            duration: SLIDE_DURATION,
            ease: SLIDE_EASE,
            onComplete: () => {
              isChildrenColumnVisible = true;
            }
          });
        }
      });
    } else {
      // Desktop behavior - check if column is visible AND if it's the same parent
      const currentX = gsap.getProperty(childrenColumn, "x");
      const isVisible = currentX === 0 || currentX === "0%" || currentX === "0";
      
      // Exit early only if showing the same parent AND column is actually visible AND not animating
      if (currentParentId === parentId && isVisible && !isChildrenAnimating) {
        return;
      }

      // Check if grandchildren is visible and hide it FIRST (before killing other animations)
      const grandchildrenX = gsap.getProperty(grandchildrenColumn, "x");
      const grandchildrenVisible = grandchildrenX === 0 || grandchildrenX === "0%" || grandchildrenX === "0";
      
      if (grandchildrenVisible) {
        // Hide grandchildren first with its own animation
        isGrandchildrenAnimating = true;
        gsap.to(grandchildrenColumn, {
          x: "-100%",
          opacity: 1,
          duration: SLIDE_DURATION,
          ease: "power2.in",
          overwrite: true,
          onComplete: () => {
            grandchildrenContent.innerHTML = "";
            isGrandchildrenAnimating = false;
            isGrandchildrenColumnVisible = false;
            currentChildId = null;
          },
        });
      }

      // Kill any existing animations on children elements (but not grandchildren since we just started that)
      gsap.killTweensOf([childrenColumn, childrenContent]);
      
      if (isVisible && currentParentId !== null && currentParentId !== parentId) {
        // Column is visible but switching to different parent - fade only
        isContentAnimating = true;
        gsap.to(childrenContent, {
          opacity: 0,
          duration: 0.3,
          ease: "power2.in",
          overwrite: true,
          onComplete: () => {
            currentParentId = parentId;
            currentChildId = null;
            updateChildrenContent(parentId, parentTitle, false); // false = no slide

            gsap.to(childrenContent, {
              opacity: 1,
              duration: 0.3,
              ease: "power2.out",
              overwrite: true,
              onComplete: () => {
                isContentAnimating = false;
              }
            });
          },
        });
      } else {
        // Column is not visible OR we're showing the same parent after it was hidden - slide and fade
        currentParentId = parentId;
        currentChildId = null;
        updateChildrenContent(parentId, parentTitle, true); // true = slide
        isChildrenColumnVisible = true;
      }
    }
  }

  // Update children content with slide parameter
  function updateChildrenContent(parentId, parentTitle, shouldSlide = true) {
    const children = menuData[parentId]?.children || [];

    if (children.length === 0) {
      return;
    }

    // Set parent title for mobile
    if (childrenTitle && isMobile()) {
      childrenTitle.textContent = parentTitle || "";
    }

    // Build the HTML
    let childrenHtml = '<ul class="mega-menu__dynamic-list">';

    children.forEach((child) => {
      const hasGrandchildren = child.children && child.children.length > 0;
      childrenHtml += `<li class="mega-menu__child-item">
                <a href="${child.url}" 
                   data-id="${child.id}" 
                   class="${hasGrandchildren ? "has-children" : ""}">
                   ${child.title}
                </a>
            </li>`;
    });

    childrenHtml += "</ul>";
    childrenContent.innerHTML = childrenHtml;

    attachChildrenListeners();

    if (!isMobile()) {
      if (shouldSlide) {
        // Kill any existing animations on children column
        gsap.killTweensOf(childrenColumn);
        
        // Desktop - slide column in
        isChildrenAnimating = true;
        gsap.set(childrenColumn, {
          x: "-100%",
          opacity: 1,
        });

        gsap.to(childrenColumn, {
          x: "0%",
          opacity: 1,
          duration: SLIDE_DURATION,
          ease: SLIDE_EASE,
          overwrite: true,
          onComplete: () => {
            isChildrenAnimating = false;
            // Animate individual items after column slides in
            animateChildItems();
          }
        });
      } else {
        // Just animate the items, no column slide
        animateChildItems();
      }
    }
  }

  // New function to animate individual child items
  function animateChildItems() {
    // No animation needed - items appear immediately
  }

  // Show grandchildren column
  function showGrandchildrenColumn(childId, childTitle) {
    if (isMobile()) {
      // Mobile behavior with sequential animation
      currentChildId = childId;
      const parentItem = menuData[currentParentId];
      navigationStack.push({
        type: "child",
        id: childId,
        title: childTitle,
        parentId: currentParentId,
      });
      updateGrandchildrenContent(childId, childTitle);

      // Slide children column to the left
      gsap.to(childrenColumn, {
        x: "-100%",
        duration: SLIDE_DURATION,
        ease: "power2.in",
        onComplete: () => {
          // Slide grandchildren column in from right AFTER children slides out
          gsap.to(grandchildrenColumn, {
            x: "0%",
            duration: SLIDE_DURATION,
            ease: SLIDE_EASE,
            onComplete: () => {
              isGrandchildrenColumnVisible = true;
            }
          });
        }
      });
    } else {
      // Desktop behavior - check if column is visible
      const currentX = gsap.getProperty(grandchildrenColumn, "x");
      const isVisible = currentX === 0 || currentX === "0%" || currentX === "0";

      // Exit early if showing the same child AND column is visible AND not animating
      if (currentChildId === childId && isVisible && !isGrandchildrenAnimating) {
        return;
      }

      // Kill any existing grandchildren animations
      gsap.killTweensOf([grandchildrenColumn, grandchildrenContent]);
      
      if (isVisible && currentChildId !== null && currentChildId !== childId) {
        // Column is visible but switching - fade only
        isContentAnimating = true;
        gsap.to(grandchildrenContent, {
          opacity: 0,
          duration: 0.3,
          ease: "power2.in",
          overwrite: true,
          onComplete: () => {
            currentChildId = childId;
            updateGrandchildrenContent(childId, childTitle, false); // false = no slide

            gsap.to(grandchildrenContent, {
              opacity: 1,
              duration: 0.3,
              ease: "power2.out",
              overwrite: true,
              onComplete: () => {
                isContentAnimating = false;
              }
            });
          },
        });
      } else {
        // Column is not visible - slide and animate items
        currentChildId = childId;
        updateGrandchildrenContent(childId, childTitle, true); // true = slide
        isGrandchildrenColumnVisible = true;
      }
    }
  }

  // Update grandchildren content with slide parameter
  function updateGrandchildrenContent(childId, childTitle, shouldSlide = true) {
    const parentItem = menuData[currentParentId];
    const childItem = parentItem?.children?.find((c) => c.id === childId);
    const grandchildren = childItem?.children || [];

    if (grandchildren.length === 0) {
      return;
    }

    // Set parent title for mobile
    if (grandchildrenTitle && isMobile()) {
      grandchildrenTitle.textContent = childTitle || "";
    }

    let grandchildrenHtml = '<ul class="mega-menu__dynamic-list">';

    grandchildren.forEach((grandchild) => {
      grandchildrenHtml += `<li class="mega-menu__grandchild-item">
                <a href="${grandchild.url}">
                   ${grandchild.title}
                </a>
            </li>`;
    });

    grandchildrenHtml += "</ul>";
    grandchildrenContent.innerHTML = grandchildrenHtml;

    attachGrandchildrenListeners();

    if (!isMobile()) {
      if (shouldSlide) {
        // Kill any existing animations on grandchildren column
        gsap.killTweensOf(grandchildrenColumn);
        
        // Desktop - slide column in
        isGrandchildrenAnimating = true;
        gsap.set(grandchildrenColumn, {
          x: "-100%",
          opacity: 1,
        });

        gsap.to(grandchildrenColumn, {
          x: "0%",
          opacity: 1,
          duration: SLIDE_DURATION,
          ease: SLIDE_EASE,
          overwrite: true,
          onComplete: () => {
            isGrandchildrenAnimating = false;
            // Animate individual items after column slides in
            animateGrandchildItems();
          }
        });
      } else {
        // Just animate the items, no column slide
        animateGrandchildItems();
      }
    }
  }

  // New function to animate individual grandchild items
  function animateGrandchildItems() {
    // No animation needed - items appear immediately
  }

  // Hide children column
  function hideChildrenColumn(callback) {
    isChildrenColumnVisible = false;
    currentParentId = null; // Reset currentParentId when hiding
    
    // Kill any existing animations on children elements
    gsap.killTweensOf([childrenColumn, childrenContent]);
    
    if (isMobile()) {
      // Mobile - slide out to right
      gsap.to(childrenColumn, {
        x: "100%",
        duration: SLIDE_DURATION,
        ease: "power2.in",
        overwrite: true,
        onComplete: () => {
          childrenContent.innerHTML = "";
          resetAnimationStates();
          if (callback) callback();
        },
      });
    } else {
      // Desktop - slide to left
      isChildrenAnimating = true;
      gsap.to(childrenColumn, {
        x: "-100%",
        opacity: 1,
        duration: SLIDE_DURATION,
        ease: "power2.in",
        overwrite: true,
        onComplete: () => {
          childrenContent.innerHTML = "";
          isChildrenAnimating = false;
          if (callback) callback();
        },
      });
    }
  }

  // Hide grandchildren column
  function hideGrandchildrenColumn(callback) {
    isGrandchildrenColumnVisible = false;
    currentChildId = null; // Reset currentChildId when hiding
    
    // Kill any existing animations on grandchildren elements
    gsap.killTweensOf([grandchildrenColumn, grandchildrenContent]);
    
    if (isMobile()) {
      // Mobile - slide out to right
      gsap.to(grandchildrenColumn, {
        x: "100%",
        duration: SLIDE_DURATION,
        ease: "power2.in",
        overwrite: true,
        onComplete: () => {
          grandchildrenContent.innerHTML = "";
          resetAnimationStates();
          if (callback) callback();
        },
      });
    } else {
      // Desktop - slide to left
      isGrandchildrenAnimating = true;
      gsap.to(grandchildrenColumn, {
        x: "-100%",
        opacity: 1,
        duration: SLIDE_DURATION,
        ease: "power2.in",
        overwrite: true,
        onComplete: () => {
          grandchildrenContent.innerHTML = "";
          isGrandchildrenAnimating = false;
          if (callback) callback();
        },
      });
    }
  }

  // Handle back button navigation
  function handleBackNavigation() {
    if (navigationStack.length === 0) return;

    const lastNavigation = navigationStack.pop();

    if (lastNavigation.type === "child") {
      // Going back from grandchildren to children
      currentChildId = null;

      // Slide grandchildren out to right
      gsap.to(grandchildrenColumn, {
        x: "100%",
        duration: SLIDE_DURATION,
        ease: "power2.in",
        onComplete: () => {
          grandchildrenContent.innerHTML = "";

          // Slide children back in from left
          gsap.to(childrenColumn, {
            x: "0%",
            duration: SLIDE_DURATION,
            ease: SLIDE_EASE,
          });
        },
      });
    } else if (lastNavigation.type === "parent") {
      // Going back from children to parent
      currentParentId = null;

      // Slide children out to right
      gsap.to(childrenColumn, {
        x: "100%",
        duration: SLIDE_DURATION,
        ease: "power2.in",
        onComplete: () => {
          childrenContent.innerHTML = "";

          // Slide parent back in from left
          gsap.to(parentColumn, {
            x: "0%",
            duration: SLIDE_DURATION,
            ease: SLIDE_EASE,
          });
        },
      });
    }

    // Hide back button if we're back at the parent level
    if (navigationStack.length === 0) {
      hideBackButton();
    }
  }

  // Attach parent listeners
  function attachParentListeners() {
    const parentLinks = document.querySelectorAll(
      ".mega-menu__list--parents > li > a"
    );

    parentLinks.forEach((link) => {
      const menuItem = link.closest(".menu-item");
      const submenu = menuItem?.querySelector(".sub-menu");

      if (submenu) {
        link.classList.add("has-children");
        const parentId =
          link.getAttribute("data-id") || Math.random().toString(36);
        link.setAttribute("data-id", parentId);

        menuData[parentId] = {
          title: link.textContent.trim(),
          url: link.href,
          children: parseSubmenu(submenu),
        };
      }

      link.addEventListener("mouseenter", function (e) {
        if (isMobile()) return; // No hover on mobile

        document
          .querySelectorAll(".mega-menu__list--parents > li > a")
          .forEach((a) => a.classList.remove("active"));
        this.classList.add("active");

        const parentId = this.getAttribute("data-id");
        if (parentId && menuData[parentId]) {
          showChildrenColumn(parentId, this.textContent.trim());
        } else {
          // Kill any existing animations before hiding
          killAllColumnAnimations();
          hideChildrenColumn();
        }
      });

      link.addEventListener("click", function (e) {
        if (this.classList.contains("has-children")) {
          e.preventDefault();

          if (isMobile()) {
            // On mobile, click opens the submenu
            document
              .querySelectorAll(".mega-menu__list--parents > li > a")
              .forEach((a) => a.classList.remove("active"));
            this.classList.add("active");

            const parentId = this.getAttribute("data-id");
            if (parentId && menuData[parentId]) {
              showChildrenColumn(parentId, this.textContent.trim());
            }
          }
        }
      });
    });
  }

  // Parse submenu structure
  function parseSubmenu(submenu) {
    const children = [];
    const innerMenu = submenu.querySelector(".sub-menu--inner");
    const items = innerMenu
      ? innerMenu.querySelectorAll(":scope > .menu-item")
      : [];

    items.forEach((item) => {
      // Skip back buttons that WordPress adds
      if (
        item.classList.contains("menu-item-back") ||
        item.classList.contains("menu-item-type-back")
      )
        return;

      const link = item.querySelector(":scope > a");
      const childSubmenu = item.querySelector(":scope > .sub-menu");
      const childId = Math.random().toString(36);

      if (link) {
        const child = {
          id: childId,
          title: link.textContent.trim(),
          url: link.href,
          children: [],
        };

        if (childSubmenu) {
          child.children = parseGrandchildren(childSubmenu);
        }

        children.push(child);
      }
    });

    return children;
  }

  // Parse grandchildren
  function parseGrandchildren(submenu) {
    const grandchildren = [];
    const innerMenu = submenu.querySelector(".sub-menu--inner");
    const items = innerMenu
      ? innerMenu.querySelectorAll(":scope > .menu-item")
      : [];

    items.forEach((item) => {
      // Skip back buttons that WordPress adds
      if (
        item.classList.contains("menu-item-back") ||
        item.classList.contains("menu-item-type-back")
      )
        return;

      const link = item.querySelector(":scope > a");
      if (link) {
        grandchildren.push({
          title: link.textContent.trim(),
          url: link.href,
        });
      }
    });

    return grandchildren;
  }

  // Attach children listeners
  function attachChildrenListeners() {
    const childLinks = childrenContent.querySelectorAll("a");

    childLinks.forEach((link) => {
      link.addEventListener("mouseenter", function (e) {
        if (isMobile()) return; // No hover on mobile

        childrenContent
          .querySelectorAll("a")
          .forEach((a) => a.classList.remove("active"));
        this.classList.add("active");

        const childId = this.getAttribute("data-id");
        if (childId && this.classList.contains("has-children")) {
          showGrandchildrenColumn(childId, this.textContent.trim());
        } else {
          hideGrandchildrenColumn();
        }
      });

      link.addEventListener("click", function (e) {
        if (this.classList.contains("has-children")) {
          e.preventDefault();

          if (isMobile()) {
            // On mobile, click opens the submenu
            childrenContent
              .querySelectorAll("a")
              .forEach((a) => a.classList.remove("active"));
            this.classList.add("active");

            const childId = this.getAttribute("data-id");
            if (childId) {
              showGrandchildrenColumn(childId, this.textContent.trim());
            }
          }
        }
      });
    });
  }

  // Attach grandchildren listeners
  function attachGrandchildrenListeners() {
    // No special listeners needed for grandchildren
  }

  // Initialize
  setTimeout(() => {
    attachParentListeners();
  }, 100);

  // Open menu - MODIFIED to preserve scroll position
  function openMenu() {
    if (isMenuOpen || isAnimating) return;

    // Pause ScrollSmoother immediately when menu starts opening
    pauseScrollSmoother();
    
    // Preserve scroll position BEFORE adding the class
    preserveScrollPosition();

    isAnimating = true;
    isMenuOpen = true;
    menuButton.classList.add("active");
    menuTimeline.play();

    // Reset animation flag after menu is fully open
    setTimeout(() => {
      isAnimating = false;
    }, 2000);
  }

  // Close menu - MODIFIED to handle scroll position restoration
  function closeMenu() {
    if (!isMenuOpen || isAnimating) return;

    isAnimating = true;
    isMenuOpen = false;
    menuButton.classList.remove("active");

    // Restore scroll position IMMEDIATELY when closing starts
    restoreScrollPosition();

    // Create a closing timeline for better control
    const closeTimeline = gsap.timeline({
      onComplete: function () {
        menuTimeline.reverse();
        // Scroll position already restored above
      },
    });

    // First, animate out social items and close text
    closeTimeline
      .to([socialItems], {
        opacity: 0,
        y: 20,
        duration: 0.3,
        stagger: 0.02,
        ease: "power2.in",
      })
      .to(contactItems, {
        opacity: 0,
        y: 20,
        duration: 0.3,
        ease: "power2.in",
      })

    closeTimeline.to(closeText, {
        opacity: 0,
        x: 20,
        duration: 0.3,
        stagger: 0.02,
        ease: "power2.in",
    }, "-=0.3");

    // Check which columns are visible and animate them out
    const grandchildrenX = gsap.getProperty(grandchildrenColumn, "x");
    const childrenX = gsap.getProperty(childrenColumn, "x");
    const grandchildrenVisible = grandchildrenX === 0 || grandchildrenX === "0%" || grandchildrenX === "0";
    const childrenVisible = childrenX === 0 || childrenX === "0%" || childrenX === "0";

    if (isMobile()) {
      // Mobile - keep existing slide out behavior
      if (grandchildrenVisible) {
        closeTimeline
          .to(grandchildrenColumn, {
            x: "-350%",
            duration: SLIDE_DURATION,
            ease: "power2.in",
          }, "-=0.2");
      }

      if (childrenVisible) {
        closeTimeline
          .to(childrenColumn, {
            x: "-250%",
            duration: SLIDE_DURATION,
            ease: "power2.in",
          }, grandchildrenVisible ? "-=0.2" : "-=0.3");
      }
    } else {
      // Desktop - fade out children and grandchildren at the same time
      const columnsToFade = [];
      
      if (grandchildrenVisible) {
        columnsToFade.push(grandchildrenColumn);
      }
      
      if (childrenVisible) {
        columnsToFade.push(childrenColumn);
      }
      
      if (columnsToFade.length > 0) {
        closeTimeline
          .to(columnsToFade, {
            opacity: 0,
            duration: 0.3,
            ease: "power2.in",
          }, "-=0.2");
      }
    }

    // Always slide out parent column and animate out logo/buttons
    closeTimeline
      .to(parentColumn, {
        x: "-100%",
        opacity: 0,
        duration: SLIDE_DURATION,
        ease: "power2.in",
      }, "-=0.2")
      .to([megaMenuLogo, closeButton], {
        x: function (i) {
          return i === 0 ? -100 : 100;
        },
        opacity: 0,
        duration: 0.3,
        ease: "power2.in",
      }, "-=0.3")
      .to(searchButton, {
        x: 100,
        opacity: 0,
        duration: 0.3,
        ease: "power2.in",
      }, "-=0.3")
      .to(backButton, {
        x: 20,
        opacity: 0,
        duration: 0.3,
        ease: "power2.in",
      }, "-=0.3");
  }

  // Toggle menu
  function toggleMenu() {
    if (isMenuOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  // Event listeners
  menuButton.addEventListener("click", toggleMenu);

  if (closeButton) {
    closeButton.addEventListener("click", closeMenu);
  }

  if (closeText) {
    closeText.addEventListener("click", closeMenu);
  }

  if (backButton) {
    backButton.addEventListener("click", handleBackNavigation);
  }

  // Escape key to close
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && isMenuOpen) {
      closeMenu();
    }
  });

  // Window resize handler
  window.addEventListener("resize", function () {
    // Reset menu on resize to prevent layout issues
    if (isMenuOpen) {
      //closeMenu();
    }
  });
  
  // Expose timeline for coordination
  window.megaMenuTimeline = menuTimeline;
  
  // Expose functions for coordination with search menu
  window.megaMenuFunctions = {
    openMenu: openMenu,
    closeMenu: closeMenu,
    isMenuOpen: () => isMenuOpen,
    getTimeline: () => menuTimeline,
    pauseScrollSmoother: pauseScrollSmoother,
    resumeScrollSmoother: resumeScrollSmoother,
    resetMenuState: function() {
      //console.log("Resetting mega menu state");
      
      // Resume ScrollSmoother if it was paused
      resumeScrollSmoother();
      
      // Restore scroll position if menu was open
      if (isMenuOpen) {
        restoreScrollPosition();
      }
      
      // Reset to initial state without animations
      isMenuOpen = false;
      isAnimating = false;
      menuButton.classList.remove("active");
      
      // CRITICAL: Clear all transforms and reset all GSAP states completely
      gsap.set(megaMenu, { 
        top: "-100dvh",
        clearProps: "all"
      });
      gsap.set(megaMenuLogo, { 
        x: -100, 
        opacity: 0,
        clearProps: "transform,opacity"
      });
      gsap.set(closeButton, { 
        x: 100, 
        opacity: 0,
        clearProps: "transform,opacity"
      });
      gsap.set(searchButton, { 
        x: 100, 
        opacity: 0,
        visibility: "visible", // Ensure it's visible for next opening
        clearProps: "transform,opacity"
      });
      gsap.set(closeText, { 
        x: 20, 
        opacity: 0,
        clearProps: "transform,opacity"
      });
      gsap.set(parentColumn, { 
        x: "-100%", 
        opacity: 0,
        clearProps: "transform,opacity"
      });
      gsap.set(childrenColumn, { 
        x: isMobile() ? "100%" : "-100%", 
        opacity: 1, 
        visibility: "visible",
        clearProps: "transform,opacity"
      });
      gsap.set(grandchildrenColumn, { 
        x: isMobile() ? "100%" : "-100%", 
        opacity: 1, 
        visibility: "visible",
        clearProps: "transform,opacity"
      });
      gsap.set(socialItems, { 
        opacity: 0, 
        y: 20,
        clearProps: "transform,opacity"
      });
      gsap.set(contactItems, { 
        opacity: 0, 
        y: 20,
        clearProps: "transform,opacity"
      });
      gsap.set(".mega-menu__list--parents > li", { 
        opacity: 0, 
        x: -50,
        clearProps: "transform,opacity"
      });
      
      if (isMobile()) {
        gsap.set(backButton, { 
          x: 20, 
          opacity: 0, 
          visibility: "hidden",
          clearProps: "transform,opacity"
        });
        navigationStack = [];
      }
      
      if (searchWrapper && isMobile()) {
        gsap.set(searchWrapper, { 
          opacity: 0, 
          x: -50,
          clearProps: "transform,opacity"
        });
      }
      
      // CRITICAL: Reset container positions that may have been moved during coordination
      const megaMenuContainer = document.querySelector(".mega-menu__container");
      const megaMenuFooter = document.querySelector(".mega-menu__footer");
      if (megaMenuContainer && megaMenuFooter) {
        gsap.set([megaMenuContainer, megaMenuFooter], {
          x: "0%",
          clearProps: "all"
        });
      }
      
      // Clear content and reset variables
      if (childrenContent) childrenContent.innerHTML = "";
      if (grandchildrenContent) grandchildrenContent.innerHTML = "";
      currentParentId = null;
      currentChildId = null;
      isChildrenColumnVisible = false;
      isGrandchildrenColumnVisible = false;
      
      // Kill any running animations
      gsap.killTweensOf([megaMenu, megaMenuLogo, closeButton, searchButton, closeText, parentColumn, childrenColumn, grandchildrenColumn, socialItems, contactItems]);
      
      // CRITICAL: Reset the timeline to ensure it can play again
      if (menuTimeline) {
        //console.log("Resetting menu timeline");
        menuTimeline.progress(0).pause();
        menuTimeline.kill();
        
        // Recreate the timeline fresh
        menuTimeline = gsap.timeline({
          paused: true,
          onComplete: function () {
            showParentColumn();
          },
          onReverseComplete: function () {
            // Resume ScrollSmoother when menu is fully closed
            resumeScrollSmoother();
          },
        });
        
        // Rebuild the timeline animation
        menuTimeline.to(megaMenu, {
          top: 0,
          duration: 0.6,
          ease: "power2.inOut",
        });
        
        // Re-expose the new timeline
        window.megaMenuTimeline = menuTimeline;
      }
      
      //console.log("Mega menu state reset complete");
    }
  };
});